import LocalizedStrings from 'react-localization'
import { get } from 'lodash'

import enTranslations from '../lang/en.json'
import history from '../history'

import { SUPPORTED_LANGS } from './consts.mjs'

const strings = new LocalizedStrings({ en: enTranslations })

export const enTranslate = (key) => get(enTranslations, key, key)

export const translate = (key, ...args) => {
  try {
    return strings.formatString(get(strings, key, key), ...args)
  } catch (error) {
    typeof key === 'string' && console.error('translation error for ', key)

    return get(strings, key, key)
  }
}

export const withLanguageRoutes = (path, query = '') => {
  const languageCode = getLanguageCode()
  if (path.indexOf(`/${languageCode}`) === 0) {
    return `${path}${query}`
  }
  return `/${languageCode}${path}${query}`
}

export const pushWithLanguageRoutes = (path, state) =>
  history.push(withLanguageRoutes(path), state)

export const replaceWithLanguageRoutes = (path, state) =>
  history.replace(withLanguageRoutes(path), state)

// Language codes aren't standarized
export const supportedLangs = SUPPORTED_LANGS

export const setLanguageCode = (code) => {
  const languageCode = code || getLanguageCode()
  if (code) {
    return Promise.resolve().then(() => {
      strings.setLanguage(code)
      storeCurrLang(code)
    })
  }
  if (languageCode === 'en') {
    return Promise.resolve().then(() => {
      strings.setContent({
        en: { ...enTranslations },
      })
      strings.setLanguage(languageCode)
      storeCurrLang(languageCode)
    })
  }
  return Promise.all([
    import(`../lang/${languageCode}.json`),
    import(`../lang/country.${languageCode}.json`),
  ]).then(([lang, countries]) => {
    strings.setContent({
      en: { ...enTranslations },
      [languageCode]: { ...lang, ...countries },
    })
    strings.setLanguage(languageCode)
    storeCurrLang(languageCode)
  })
}

const legacyCodes = {
  jp: 'ja',
  cn: 'zh',
  br: 'pt',
}

export const LEGACY_CODES = Object.keys(legacyCodes)

export const fromLegacyCode = (code) => legacyCodes[code] || code

export const toLegacyCode = (code) => {
  const oldCodePair = Object.entries(legacyCodes).find(
    ([_, newCode]) => newCode === code,
  )
  return (oldCodePair && oldCodePair[0]) || code
}

export const getLanguageCode = () => {
  // Priority order:
  // 1. From current pathname
  // 2. From session Storage
  // 3. From navigator language
  // 4. Default 'en'
  const path = window.location.pathname.split('/')
  const fromPath = path.length > 1 ? path[1] : null
  const fromStorage = localStorage.getItem('language')
  const fromBrowser = navigator.language.split('-', 1)[0]
  const defaultLanguage = 'en'
  return [fromPath, fromStorage, fromBrowser, defaultLanguage]
    .map((lang) => fromLegacyCode(lang))
    .find((lang) => supportedLangs.includes(lang))
}

export const storeCurrLang = (langCode) => {
  localStorage.setItem('language', langCode)
}

export const isJapaneseOrChineseText = (text) => {
  const japaneseChineseRegex = /[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF]/
  return japaneseChineseRegex.test(text)
}

export const isJapaneseOrChineseLanguage = () =>
  ['zh', 'ja'].includes(getLanguageCode())

export const translateFreeTrialWarning = (paymentMethodType) => {
  const message =
    paymentMethodType === 'paypal'
      ? 'multiple_free_trial_paypal_warning'
      : 'multiple_free_trial_warning'
  return translate(message)
}
